import React from 'react'

export default ({ children }) => <main>{children}</main>
